import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const WORK_LOCATION_TYPES = [
  { code: "job", label: "Job" },
  { code: "shop", label: "Shop" },
  { code: "travel", label: "Travel" },
];

function getInitialCodes(filter) {
  const rules = filter?.rules;
  if (rules && rules.length > 0 && Array.isArray(rules[0].wloc?.codes)) {
    return rules[0].wloc.codes;
  }
  return [];
}

export default function WorkLocationsFilterModal({
  open,
  groupUuid,
  companyUuid,
  filter,
  onSave,
  onClose,
  readOnly = false,
}) {
  const [allowedCodes, setAllowedCodes] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setAllowedCodes(getInitialCodes(filter));
    setError(null);
  }, [open, filter]);

  if (!open) return null;

  function toggleCode(code) {
    setAllowedCodes((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]
    );
  }

  function handleSave() {
    const rules = [{ filter_type: "include", wloc: { codes: allowedCodes } }];

    onSave({ resource: "wloc", mode: "filtered", rules });
  }

  return (
    <div className="jfm-overlay" onClick={onClose}>
      <div
        className="jfm-container wlfm-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="jfm-header">
          <span className="jfm-title">Work Locations Filters</span>
          <button className="jfm-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="jfm-body">
          <fieldset className="jfm-fieldset" disabled={readOnly}>
            {!readOnly && (
              <div className="wlfm-all-none">
                <button
                  className="wlfm-preset-btn"
                  onClick={() =>
                    setAllowedCodes(WORK_LOCATION_TYPES.map((t) => t.code))
                  }
                >
                  All
                </button>
                <button
                  className="wlfm-preset-btn"
                  onClick={() => setAllowedCodes([])}
                >
                  None
                </button>
              </div>
            )}

            <table className="wlfm-table">
              <thead>
                <tr>
                  <th>Allow</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                {WORK_LOCATION_TYPES.map(({ code, label }) => (
                  <tr key={code}>
                    <td>
                      <input
                        type="checkbox"
                        checked={allowedCodes.includes(code)}
                        onChange={() => toggleCode(code)}
                      />
                    </td>
                    <td>{label}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </fieldset>
        </div>

        {error && <div className="jfm-error">{error}</div>}

        <div className="jfm-footer">
          <div />
          <div className="jfm-footer-actions">
            {readOnly ? (
              <button className="jfm-cancel" onClick={onClose}>
                Close
              </button>
            ) : (
              <>
                <button
                  className="jfm-cancel"
                  onClick={onClose}
                  disabled={saving}
                >
                  Cancel
                </button>
                <button
                  className="jfm-save"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving ? "Saving..." : "Save"}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
